import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const Footer = ({ categoriesList }) => {
  const [num, setNum] = useState(0);
  const [queryParameters] = useSearchParams();
  const hasCategories = categoriesList.length > 0;
  const queryParams = [];
  if (queryParameters.get("gclid")) {
    queryParams.push("gclid=" + queryParameters.get("gclid"));
  }
  useEffect(() => {
    if (categoriesList.length > 6 && categoriesList.length) {
      setNum(categoriesList.length / 2 + 0.5);
    } else if (categoriesList.length > 6) {
      setNum(categoriesList.length / 2);
    }
  }, [categoriesList]);

  const removeTitle = () => {
    localStorage.removeItem("categoryName");
    localStorage.removeItem("categoryId");
    localStorage.removeItem("categoryProvider");
  };

  return (
    <footer className="axil-footer-area footer-style-2">
      <div className="footer-top">
        <div className="container">
          <div
            className={`footer-layout ${hasCategories ? "" : "footer-layout--single-nav"}`.trim()}
          >
            <div className="footer-brand-column">
              <div className="axil-footer-widget logo-wrap">
                <a
                  href={
                    "/" +
                    (queryParams.length > 0 ? "?" + queryParams.join("&") : "")
                  }
                  onClick={removeTitle}
                  className="logo logo-dark"
                >
                  <img src={`/images/logo/logo.webp`} alt="Site Logo" width={220} height={24} />
                </a>
              </div>

              <div className="copyright-area copyright-default footer-copyright">
                <div className="copyright-left">
                  <ul className="quick-link">
                    <li>
                      © {new Date().getFullYear()}. All rights reserved by{" "}
                      <a
                        href={
                          "/" +
                          (queryParams.length > 0
                            ? "?" + queryParams.join("&")
                            : "")
                        }
                        onClick={removeTitle}
                      >
                        Rainbowsoffers
                      </a>
                      .
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="footer-nav-column">
              <div className="axil-footer-widget">
                <h5 className="widget-title">Pages</h5>
                <div className="inner">
                  <ul>
                    <li>
                      <a href={"/about" + window.location?.search}>About Us</a>
                    </li>
                    <li>
                      <a href={"/privacy" + window.location?.search}>
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href={"/terms" + window.location?.search}>
                        Terms Of Use
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {hasCategories && (
              <div className="footer-category-column">
                <div className="axil-footer-widget">
                  <h5 className="widget-title">Category</h5>
                  <div className="inner">
                    <ul
                      className={
                        categoriesList.length > 6 ? "two-col-list" : ""
                      }
                    >
                      {categoriesList.length > 6 ? (
                        <>
                          <li className="left-block">
                            <ul>
                              {categoriesList.slice(0, num).map((itm) => (
                                <li key={itm.id}>
                                  <a
                                    href={
                                      process.env.REACT_APP_API_URL +
                                      itm.path +
                                      (queryParams.length > 0
                                        ? "?" + queryParams.join("&")
                                        : "")
                                    }
                                    onClick={removeTitle}
                                  >
                                    {itm.name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </li>
                          <li className="right-block">
                            <ul>
                              {categoriesList.slice(num).map((itm) => (
                                <li key={itm.id}>
                                  <a
                                    href={
                                      process.env.REACT_APP_API_URL +
                                      itm.path +
                                      (queryParams.length > 0
                                        ? "?" + queryParams.join("&")
                                        : "")
                                    }
                                    onClick={removeTitle}
                                  >
                                    {itm.name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </li>
                        </>
                      ) : (
                        categoriesList.map((itm) => (
                          <li key={itm.id}>
                            <a href={itm.path}>{itm.name}</a>
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
